import { MENU_ACTIONS } from '../../constants/actions'

export const MENU_FUNCTIONS = {

  onMenuMouseEnter: () => ({    
    type: MENU_ACTIONS.ON_MENU_MOUSE_ENTER
  }),

  onMenuMouseLeave: () => ({
    type: MENU_ACTIONS.ON_MENU_MOUSE_LEAVE
  }),

  onMenuClick: () => ({
    type: MENU_ACTIONS.ON_MENU_CLICK
  }),

  closeMenu: () => ({
    type: MENU_ACTIONS.ON_CLOSE_MENU
  })

}



// WEBPACK FOOTER //
// ./src/store/actions/menu.js